<template>
  <v-toolbar
    flat
    dark
    height="48"
    max-height="48"
    color="secondary"
  >
    <v-tabs
      v-model="groupTab"
      show-arrows
      grow
      slider-color="primary"
      @change="$emit('change')"
    >
      <v-tab
        v-for="group in groups"
        :key="group.id"
        v-text="group.name"
      />
    </v-tabs>
  </v-toolbar>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('catalog', [
        'groups',
      ]),
      groupTab: {
        get () {
          return this.$store.state.catalog.groupTab
        },
        set (v) {
          this.$store.commit('catalog/groupTab', v)
        },
      },
    },
  }
</script>
